<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="ListRect">
      <div class="Rect">
        <div class="account">
          <van-row>
            <van-col span="8">到账账户</van-col>
            <van-col v-if="list.length>0" span="16">
              <div @click="onSelectAccount">
                <span v-if="selectAccount.cashType==='OFFLINE'">线下支付</span>
                <span v-if="selectAccount.cashType==='ALIPAY_TRANSFER'">支付宝</span>
                <span v-if="selectAccount.cashType==='WECHAT_TRANSFER'">微信</span>
                <span v-if="selectAccount.cashType==='BANK'">{{ selectAccount.bankName }}</span>

                <span v-if="selectAccount.cashType==='OFFLINE'">({{ selectAccount.cashName }})</span>
                <span v-if="selectAccount.cashType!=='OFFLINE'">({{ selectAccount.cashAccount }})</span>
                <div class="cashTime">约定工作日内到账</div>
              </div>
            </van-col>
            <van-col v-if="list.length<=0" span="16">
              <div @click="onAddAccount">添加账号<div class="cashTime">支持网银、支付宝、微信</div></div>
            </van-col>
          </van-row>
        </div>
        <div class="price">
          提现金额
          <van-row>
            <van-col span="5"><span class="priceCurrency">{{ priceData.currency }}</span></van-col>
            <van-col span="19">
              <van-field
                readonly
                clickable
                size="large"
                style="font-size:2em;"
                :value="price"
                @touchstart.native.stop="showPriceSelect = true"
              /></van-col>
          </van-row>
          <div class="priceAbout">
            当前可用余额{{ ShowMoney(priceData.money) }}元，<span :style="'color: '+GetColorSecondary()" @click="cashForAll">全部提现</span><br>
            本次提交由<b :style="'color: '+GetColorMain()">{{ priceData.manageName }}</b>负责结算。
          </div>
          <van-button type="primary" :loading="buttonLoading" :color="GetColorMain()" style="width:100%" @click="onCash">提现</van-button>
        </div>
      </div>
    </div>
    <van-number-keyboard
      v-model="price"
      :show="showPriceSelect"
      :maxlength="10"
      extra-key="."
      @blur="showPriceSelect = false"
    />
    <van-popup v-model="showPopupSelect" position="bottom">
      <van-picker
        show-toolbar
        :columns="selectList"
        @cancel="showPopupSelect=false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, NumberKeyboard, Field, Popup, Picker, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [NumberKeyboard.name]: NumberKeyboard,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '余额提现',
      backurl: '/store/index',
      showPriceSelect: false,
      id: undefined,
      price: '',
      list: [],
      priceData: {
      },
      selectAccount: undefined,
      showPopupSelect: false,
      selectList: [],
      buttonLoading: false
    }
  },

  created() {
    this.id = this.$route.params.id
    this.titleTop = GetSysTitle()
    this.accountList(() => {
      this.getPriceData(() => {

      })
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onSelectAccount() {
      this.showPopupSelect = true
      this.selectList = []
      this.list.forEach(item => {
        let text = ''
        if (item.cashType === 'ALIPAY_TRANSFER') {
          text = '支付宝(' + item.cashAccount + ')'
        } else if (item.cashType === 'WECHAT_TRANSFER') {
          text = '微信(' + item.cashAccount + ')'
        } else if (item.cashType === 'BANK') {
          text = item.bankName + '(' + item.cashAccount + ')'
        } else if (item.cashType === 'OFFLINE') {
          text = '线下支付(' + item.cashName + ')'
        } else {
          text = item.cashType + '(' + item.cashAccount + ')'
        }
        this.selectList.push({
          text: text,
          value: item.moneyAccountId
        })
      })
    },
    onConfirm(value) {
      this.selectAccount = undefined
      this.list.forEach(item => {
        if (item.moneyAccountId === value.value) {
          this.selectAccount = item
        }
      })
      this.showPopupSelect = false
    },
    cashForAll() {
      if (this.priceData) {
        this.price = this.priceData.money + ''
      } else {
        this.price = ''
      }
    },
    onAddAccount() {
      this.$router.push('/pro/bankEdit/0')
    },
    accountList(callback) {
      request({
        url: '/pro/GetMoneyAccountList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
        if (this.list.length > 0) {
          this.selectAccount = this.list[0]
        }
        if (callback) {
          callback()
        }
      })
    },
    getPriceData(callback) {
      request({
        url: '/pro/getUserMoneyRect',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.priceData = response.data
        if (callback) {
          callback()
        }
      })
    },
    onCash() {
      if (!this.selectAccount) {
        MyNotify('error', '请选择到账账户')
        return
      }
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (!reg.test(this.price)) {
        MyNotify('error', '请输入正确的金额')
        return
      }
      const priceInput = parseFloat(this.price)
      if (priceInput > this.priceData.money) {
        MyNotify('error', '输入金额超过可用余额')
        return
      }
      if (priceInput < 0.01) {
        MyNotify('error', '金额不可小于0')
        return
      }
      let text = ''
      if (this.selectAccount.cashType === 'ALIPAY_TRANSFER') {
        text = '支付宝(' + this.selectAccount.cashAccount + ')'
      } else if (this.selectAccount.cashType === 'WECHAT_TRANSFER') {
        text = '微信(' + this.selectAccount.cashAccount + ')'
      } else if (this.selectAccount.cashType === 'OFFLINE') {
        text = '线下支付(' + this.selectAccount.cashName + ')'
      } else if (this.selectAccount.cashType === 'BANK') {
        text = this.selectAccount.bankName + '(' + this.selectAccount.cashAccount + ')'
      } else {
        text = this.selectAccount.cashType + '(' + this.selectAccount.cashAccount + ')'
      }
      Dialog.confirm({
        title: '提现',
        message: '确认使用 ' + text + ' 提现:' + this.priceData.currency + ' ' + ShowMoney(this.price) + '?',
        cancelButtonText: '取消',
        confirmButtonText: '确认提现'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/cashMoneyApply',
          method: 'post',
          data: {
            moneyId: this.id,
            price: priceInput,
            moneyAccountId: this.selectAccount.moneyAccountId
          }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '提现成功，我们将会尽快为您处理', 5000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        })
      })
    }
  }
}
</script>
<style scoped>
.Rect{
    margin: 1em;
    border-radius: 0.4em;
    overflow: hidden;
    background-color: #fff;
    font-size: 0.9em;
}
.Rect .account .cashTime{
    color: #999;
    font-size: 0.8em;
    line-height: 2.6em;
}
.Rect .account{
    padding: 1em 2em;
    background-color: #fcfcfc;
}
.Rect .price{
     padding: 1em 2em;
}
.priceCurrency{
    font-size: 2em;
    line-height: 57px;
}

.priceAbout{
    border-top: 1px solid #dadada;
    padding: 1em 0 1em 0;
    line-height: 1.6em;
    color: #999;
}
</style>
